import Vue from 'vue';

Vue.component('vuetable-shell-reimbursement', () =>
    import(/* webpackChunkName: 'reimbursement-index' */ './vuetable-shell-reimbursement.vue'),
);
